export default __webpack_public_path__ + "static/media/conversation.cec1eb88.png";